import { useEffect, useRef, useState } from "react";

export default function StatCounter({ value, label, suffix = "", prefix = "", testid }) {
    const [display, setDisplay] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const observer = new IntersectionObserver(entries => {
            entries.forEach(e => {
                if (e.isIntersecting && !started.current) {
                    started.current = true;
                    const duration = 1600;
                    const start = performance.now();
                    const step = (t) => {
                        const p = Math.min(1, (t - start) / duration);
                        const eased = 1 - Math.pow(1 - p, 3);
                        setDisplay(Math.floor(eased * value));
                        if (p < 1) requestAnimationFrame(step);
                    };
                    requestAnimationFrame(step);
                }
            });
        }, { threshold: 0.3 });
        observer.observe(el);
        return () => observer.disconnect();
    }, [value]);

    const format = (n) => {
        if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
        if (n >= 1_000) return (n / 1_000).toFixed(1) + "K";
        return n.toLocaleString();
    };

    return (
        <div ref={ref} className="border-l border-white/10 pl-5 md:pl-6" data-testid={testid}>
            <div className="metric-value text-4xl md:text-6xl leading-none">
                {prefix}{format(display)}{suffix}
            </div>
            <div className="text-white/50 text-xs uppercase tracking-[0.24em] mt-3 font-semibold">{label}</div>
        </div>
    );
}
